var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('with-invoice',{attrs:{"invoice-id":_vm.invoiceId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invoice = ref.invoice;
return [(invoice.status === 'Draft')?_c('div',[_c('attach-logs-to-invoice-form',{attrs:{"invoice-id":_vm.invoiceId,"affected-services":_vm.affectedServices,"log":_vm.log}}),_vm._v(" "),_c('detach-logs-to-invoice-form',{attrs:{"invoice-id":_vm.invoiceId,"affected-services":_vm.affectedServices,"log":_vm.log}})],1):_c('div')]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b33345e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/invoices/CaseInvoiceOperations.vue
// module id = null
// module chunks = 